import { v1 } from 'uuid';
import { useTranslation } from 'react-i18next';
import { toLowerCaseWithFirstLetterUpper } from '../Generics/utilsFunctions';
import fleche from 'assets/images/fleche.png';

const ObligationRestrictionTable = ({ truncatedObligationRestriction, messageDuplicate }) => {
  const { t } = useTranslation();
  return (
    <article className="pdf-page">
      <div className="tableau_center">
        <h6 className="title_h6">
          {messageDuplicate !== ''
            ? `${t('simulation.result.pdf.obligationRestriction.title')} ${messageDuplicate}`
            : t('simulation.result.pdf.obligationRestriction.title')}
        </h6>
        <table className="table">
          <thead className="table_head">
            <tr className="table_tr" key="trHead">
              <th className="column_name" key="name">
                {t('common.parcels')} /{' '}
                {t('common.cultures')}
              </th>
              <th className="column_name" key="campagne">
                {t('common.campaigns')}
              </th>
              <th className="column_name" key="state">
                {t('simulation.result.pdf.obligationRestriction.state')}
              </th>
            </tr>
          </thead>
          <tbody>
            {truncatedObligationRestriction?.map((parcel, index) => {
              return (
                <div>
                  <tr className="table_tr" key={index + 'parcel'}>
                    <th className="head_row" key={index + 'name'} colSpan="3">
                      {parcel.name}{' '}
                      {parcel?.suite ? t('simulation.common.continued') : ''}
                    </th>
                  </tr>
                  {parcel.cultures.map((culture, idx) => {
                    let tempRows = [];
                    for (const [key, value] of Object.entries(culture)) {
                      if (key === 'name' || key === 'cultureId') {
                        continue;
                      } else if (Array.isArray(value) && value?.length > 0) {
                        tempRows.push(
                          <tr className="table_tr grey_row" key={index + 'constraint' + idx}>
                            <td className="value_table" key={index + 'name' + idx}>
                              <div className="inline_icon_cell">
                                <img className="cell-icon" src={fleche} alt="Logo fleche" />
                                <span>{toLowerCaseWithFirstLetterUpper(culture?.name)}</span>
                              </div>
                            </td>
                            <td className="value_table" key={index + 'campagne' + idx}>
                              {value.map((restrict, idxRestrict) => (
                                <span key={idxRestrict}>
                                  {restrict}
                                  {idxRestrict !== value.length - 1 ? '-' : ''}
                                </span>
                              ))}
                            </td>
                            <td className="value_table" key={index + 'state' + idx}>
                              {key === 'restriction'
                                ? t(
                                    'simulation.result.pdf.obligationRestriction.constraintStates.restriction',
                                  )
                                : key === 'obligation'
                                  ? t(
                                      'simulation.result.pdf.obligationRestriction.constraintStates.obligation',
                                    )
                                  : key === 'conversion'
                                    ? t(
                                        'simulation.common.transitionBio',
                                      )
                                    : key === 'permission'
                                      ? t(
                                          'simulation.result.pdf.obligationRestriction.constraintStates.permission',
                                        )
                                      : t(
                                          'simulation.result.pdf.obligationRestriction.constraintStates.division',
                                        )}
                            </td>
                          </tr>,
                        );
                      }
                    }
                    return tempRows;
                  })}
                  {parcel.constraint === 'conversion' && (
                    <tr className="table_tr grey_row" key={v1()}>
                      <td></td>
                      <td className="value_table" key={v1()}>
                        {parcel.year}
                      </td>
                      <td className="value_table" key={v1()}>
                        {parcel.constraint === 'conversion'
                          ? t(
                              'simulation.common.transitionBio',
                            )
                          : ''}
                      </td>
                    </tr>
                  )}
                </div>
              );
            })}
          </tbody>
        </table>
      </div>
    </article>
  );
};

export default ObligationRestrictionTable;
